
import Vue from 'vue'
import { QSelect } from 'quasar';
import getPauseOptions from '@/helpers/pauseOptions'



export default Vue.extend({
    components: {  QSelect },
    props: {
        defaultValue: {
            type: Number
        }
    },
    data() {
        return {
            selected: {
                label: 'nicht pausieren',
                value: 0
            }
        }
    },
    created() {
        // @ts-ignore
        this.selected = this.options.find(o => o.value == this.defaultValue)
    },
    computed: {
        options() {
            return getPauseOptions()
        }
    }
})
